import { CloseCircleOutlined } from "@ant-design/icons";
import { Col, DatePicker, Empty, Input, Row, Select, Spin, Switch, message } from "antd";
import dayjs from "dayjs";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { apiSaveRegistrationCheckout } from "services/dashboardService";

const CheckoutTab = (props) => {
  const { Option } = Select;
  const { registrationID, settingInfo } = props;
  const userDataStore = useSelector((x) => x.userDataStore);

  const [isBusy, setIsBusy] = useState(false);
  const [errorField, setErrorField] = useState([]);
  const [discodeList, setDiscodeList] = useState([]);
  const [allowManualPayments, setAllowManualPayments] = useState(false);
  const [manualPaymentCode, setManualPaymentCode] = useState("");
  const [emailInvoicesToAdmin, setEmailInvoicesToAdmin] = useState(false);
  const [earlyRegDiscountAmount, setEarlyRegDiscountAmount] = useState("");
  const [earlyRegDiscountDate, setEarlyRegDiscountDate] = useState(null);
  const [lateRegFeeAmount, setLateRegFeeAmount] = useState("");
  const [lateRegFeeDate, setLateRegFeeDate] = useState(null);

  useEffect(() => {
    if (settingInfo != undefined) {
      let tmpDisList = Array.isArray(settingInfo.discount_codes)
        ? [...settingInfo.discount_codes]
        : [];
      tmpDisList = tmpDisList.map((x) => {
        return {
          ID: x.ID,
          visible: 1,
          text: x.discount_code,
          percentage: x.discount_percentage,
          amount: x.discount_amount,
          free: x.discount_free == "1" ? true : false,
          multipleList: [2, 3, 4, 5, 6],
          type: x.type,
          row_index: x.row_index,
        };
      });
      setDiscodeList(tmpDisList);

      setAllowManualPayments(
        settingInfo?.registration_info?.allow_manual_payments == 1
      );
      setManualPaymentCode(
        settingInfo?.registration_info?.manual_payment_code || ""
      );
      setEmailInvoicesToAdmin(
        settingInfo?.registration_info?.email_invoices_to_admin == 1
      );

      setEarlyRegDiscountAmount(
        settingInfo?.registration_info?.early_reg_discount_amount || ""
      );
      setEarlyRegDiscountDate(
        settingInfo?.registration_info?.early_reg_discount_date
          ? dayjs(settingInfo.registration_info.early_reg_discount_date)
          : null
      );
      setLateRegFeeAmount(
        settingInfo?.registration_info?.late_reg_fee_amount || ""
      );
      setLateRegFeeDate(
        settingInfo?.registration_info?.late_reg_fee_date
          ? dayjs(settingInfo.registration_info.late_reg_fee_date)
          : null
      );
    }
  }, [settingInfo]);

  const onAddCode = () => {
    let tmpList = [...discodeList];
    let oneCode = {
      text: "",
      percentage: "",
      amount: "",
      free: true,
      visible: 1,
      type: "single",
      row_index: "",
      multipleList: [2, 3, 4, 5, 6],
    };
    tmpList = [...tmpList, oneCode];
    setDiscodeList(tmpList);
  };

  const validateFields = () => {
    let errorList = Array();
    let isDuplicateRow = false;
    let tmpRow = "";
    let tmpList = [...discodeList];
    tmpList.map((x, index) => {
      if (x.type == "single") {
        if (!x.text || x.text === "") {
          errorList = [...errorList, index + "text"];
        }
      } else {
        if (!x.row_index || x.row_index === "") {
          errorList = [...errorList, index + "row_index"];
        } else {
          if (tmpRow != x.row_index) {
            tmpRow = x.row_index;
          } else {
            isDuplicateRow = true;
          }
        }
      }
      if (x.percentage == "" && x.amount == "") {
        errorList = [...errorList, index + "percentage"];
        errorList = [...errorList, index + "amount"];
      }
    });
    setErrorField([...errorList]);
    if (isDuplicateRow) {
      message.error("Participants row is duplicated.");
    }
    return errorList.length == 0 && !isDuplicateRow;
  };

  const onSave = () => {
    if (!validateFields()) return;

    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("registration_id", registrationID);
    params.append("discount_code_list", JSON.stringify(discodeList));
    params.append(
      "allow_manual_payments",
      allowManualPayments ? "1" : "0"
    );
    params.append("manual_payment_code", manualPaymentCode);
    params.append(
      "email_invoices_to_admin",
      emailInvoicesToAdmin ? "1" : "0"
    );
    params.append("early_reg_discount_amount", earlyRegDiscountAmount || "");
    params.append(
      "early_reg_discount_date",
      earlyRegDiscountDate ? earlyRegDiscountDate.format("YYYY-MM-DD") : ""
    );
    params.append("late_reg_fee_amount", lateRegFeeAmount || "");
    params.append(
      "late_reg_fee_date",
      lateRegFeeDate ? lateRegFeeDate.format("YYYY-MM-DD") : ""
    );

    setIsBusy(true);
    apiSaveRegistrationCheckout(params)
      .then((res) => {
        setIsBusy(false);
        if (res != undefined && Array.isArray(res.discount_code_list)) {
          let tmpList = [...res.discount_code_list.reverse()];
          tmpList = tmpList.map((x) => {
            return {
              ID: x.ID,
              visible: 1,
              text: x.discount_code,
              percentage: x.discount_percentage,
              amount: x.discount_amount,
              free: x.discount_free == "1" ? true : false,
              multipleList: [2, 3, 4, 5, 6],
              type: x.type,
              row_index: x.row_index,
            };
          });
          setDiscodeList(tmpList);
          message.success("Checkout settings saved successfully.");
        } else {
          message.success("Checkout settings saved.");
        }
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  return (
    <div>
      <Spin spinning={isBusy}>
        <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
          <Col xs={24} sm={12}>
            <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
              Allow Manual Payments
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <Switch
                checkedChildren="Yes"
                unCheckedChildren="No"
                checked={allowManualPayments}
                style={{ marginBottom: 10 }}
                onChange={(e) => {
                  setAllowManualPayments(e);
                  if (!e) setManualPaymentCode("");
                }}
              />
              {allowManualPayments && (
                <div style={{ flex: 1, marginBottom: 10 }}>
                  <Input
                    placeholder="Manual Payment Code"
                    value={manualPaymentCode}
                    className="common-input"
                    onChange={(e) => setManualPaymentCode(e.target.value)}
                  />
                </div>
              )}
            </div>
          </Col>
          <Col xs={24} sm={12}>
            <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
              Email Invoices To Admin
            </div>
            <Switch
              checkedChildren="Yes"
              unCheckedChildren="No"
              checked={emailInvoicesToAdmin}
              style={{ marginBottom: 10 }}
              onChange={(e) => setEmailInvoicesToAdmin(e)}
            />
          </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
          <Col xs={24} sm={12}>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>
              Early Registration Discount
            </div>
            <Row gutter={[8, 8]}>
              <Col xs={12}>
                <div style={{ paddingBottom: "5px" }}>Amount</div>
                <Input
                  value={earlyRegDiscountAmount}
                  type="number"
                  prefix="$"
                  className="common-input"
                  onChange={(e) => setEarlyRegDiscountAmount(e.target.value)}
                />
              </Col>
              <Col xs={12}>
                <div style={{ paddingBottom: "5px" }}>Deadline</div>
                <DatePicker
                  value={earlyRegDiscountDate}
                  className="common-input"
                  style={{ width: "100%" }}
                  onChange={(date) => setEarlyRegDiscountDate(date)}
                />
              </Col>
            </Row>
          </Col>
          <Col xs={24} sm={12}>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>
              Late Registration Fee
            </div>
            <Row gutter={[8, 8]}>
              <Col xs={12}>
                <div style={{ paddingBottom: "5px" }}>Amount</div>
                <Input
                  value={lateRegFeeAmount}
                  type="number"
                  prefix="$"
                  className="common-input"
                  onChange={(e) => setLateRegFeeAmount(e.target.value)}
                />
              </Col>
              <Col xs={12}>
                <div style={{ paddingBottom: "5px" }}>Start Date</div>
                <DatePicker
                  value={lateRegFeeDate}
                  className="common-input"
                  style={{ width: "100%" }}
                  onChange={(date) => setLateRegFeeDate(date)}
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
          <Col>
            <div style={{ fontWeight: 600 }}>Discount Codes</div>
          </Col>
          <Col>
            <CommonButton onClick={onAddCode}>Add New</CommonButton>
          </Col>
        </Row>

        <div>
          {discodeList != undefined && discodeList.length > 0 ? (
            <div style={{ marginTop: 20 }}>
              {discodeList.map((x, index) => {
                if (x.visible == 1) {
                  return (
                    <Row
                      key={index}
                      gutter={[16, 16]}
                      style={{ marginTop: 10 }}
                      justify={"space-between"}
                      align={"bottom"}
                    >
                      <Col xs={24} sm={5}>
                        <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                          Code Type*
                        </div>
                        <Select
                          value={x.type}
                          className={
                            errorField !== undefined &&
                            errorField.includes(index + "type")
                              ? `common-select-error`
                              : `common-select`
                          }
                          onSelect={(v) => {
                            let errors = errorField.filter(
                              (y) =>
                                y != index + "type" &&
                                y != index + "text" &&
                                y != index + "row_index"
                            );
                            setErrorField([...errors]);

                            let tmpCodeList = [...discodeList];
                            tmpCodeList[index].type = v;
                            setDiscodeList(tmpCodeList);
                          }}
                        >
                          <Option value={"single"}>Discount</Option>
                          <Option value={"multiple"}>Multiple Participants</Option>
                        </Select>
                      </Col>
                      {x.type == "single" ? (
                        <Col xs={24} sm={5}>
                          <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                            Code Text*
                          </div>
                          <Input
                            value={x.text}
                            className={
                              errorField !== undefined &&
                              errorField.includes(index + "text")
                                ? `common-input-error`
                                : `common-input`
                            }
                            onChange={(e) => {
                              if (errorField.includes(index + "text")) {
                                let errors = errorField.filter((y) => y != index + "text");
                                setErrorField([...errors]);
                              }
                              let tmpCodeList = [...discodeList];
                              tmpCodeList[index].text = e.target.value;
                              setDiscodeList(tmpCodeList);
                            }}
                          />
                        </Col>
                      ) : (
                        <Col xs={24} sm={5}>
                          <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                            # of Participants*
                          </div>
                          <Select
                            value={x.row_index}
                            className={
                              errorField !== undefined &&
                              errorField.includes(index + "row_index")
                                ? `common-select-error`
                                : `common-select`
                            }
                            onSelect={(v) => {
                              if (errorField.includes(index + "row_index")) {
                                let errors = errorField.filter((y) => y != index + "row_index");
                                setErrorField([...errors]);
                              }
                              let tmpCodeList = [...discodeList];
                              tmpCodeList[index].row_index = v;
                              setDiscodeList(tmpCodeList);
                            }}
                          >
                            {x.multipleList.map((row, rowKey) => (
                              <Option value={row} key={rowKey}>
                                {row}
                              </Option>
                            ))}
                          </Select>
                        </Col>
                      )}
                      <Col xs={24} sm={5}>
                        <div style={{ paddingBottom: "5px", fontWeight: 600 }}>Percentage</div>
                        <Input
                          value={x.percentage}
                          type={"number"}
                          suffix="%"
                          className={
                            errorField !== undefined &&
                            errorField.includes(index + "percentage")
                              ? `common-input-error`
                              : `common-input`
                          }
                          onChange={(e) => {
                            if (
                              errorField.includes(index + "percentage") ||
                              errorField.includes(index + "amount")
                            ) {
                              let errors = errorField.filter((y) => y != index + "percentage");
                              errors = errorField.filter((y) => y != index + "amount");
                              setErrorField([...errors]);
                            }
                            let tmpCodeList = [...discodeList];
                            tmpCodeList[index].percentage = e.target.value;
                            setDiscodeList(tmpCodeList);
                          }}
                        />
                      </Col>
                      <Col xs={24} sm={5}>
                        <div style={{ paddingBottom: "5px", fontWeight: 600 }}>Amount</div>
                        <Input
                          value={x.amount}
                          type={"number"}
                          prefix="$"
                          suffix="USD"
                          className={
                            errorField !== undefined &&
                            errorField.includes(index + "amount")
                              ? `common-input-error`
                              : `common-input`
                          }
                          onChange={(e) => {
                            if (
                              errorField.includes(index + "percentage") ||
                              errorField.includes(index + "amount")
                            ) {
                              let errors = errorField.filter((y) => y != index + "percentage");
                              errors = errorField.filter((y) => y != index + "amount");
                              setErrorField([...errors]);
                            }
                            let tmpCodeList = [...discodeList];
                            tmpCodeList[index].amount = e.target.value;
                            setDiscodeList(tmpCodeList);
                          }}
                        />
                      </Col>
                      <Col>
                        <div style={{ paddingBottom: "5px", fontWeight: 600 }}>Free</div>
                        <Switch
                          checkedChildren="Free"
                          unCheckedChildren="Non"
                          checked={x.free}
                          style={{ marginBottom: 10 }}
                          onChange={(e) => {
                            let tmpCodeList = [...discodeList];
                            tmpCodeList[index].free = e;
                            setDiscodeList(tmpCodeList);
                          }}
                        />
                      </Col>
                      <Col>
                        <CloseCircleOutlined
                          style={{
                            color: "red",
                            marginBottom: 15,
                            cursor: "pointer",
                            fontSize: 16,
                          }}
                          onClick={() => {
                            let tmpCodeList = [...discodeList];
                            tmpCodeList[index].visible = 0;
                            setDiscodeList(tmpCodeList);
                          }}
                        />
                      </Col>
                    </Row>
                  );
                }
              })}
            </div>
          ) : (
            <Empty description="No codes" style={{ marginTop: 20 }} />
          )}
        </div>

        <div style={{ marginTop: 60, textAlign: "center" }}>
          <CommonButton style={{ padding: "12px 45px" }} onClick={onSave}>
            Save
          </CommonButton>
        </div>
      </Spin>
    </div>
  );
};

export default CheckoutTab;
